var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4079 12.6005C4.39686 13.3782 5.64427 13.8421 7 13.8421C8.35573 13.8421 9.60315 13.3782 10.5921 12.6005",
    stroke: "#CBA624"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28947 2.46615C2.91228 3.19658 1.1842 5.40966 1.1842 8.02632C1.1842 8.6848 1.29364 9.31773 1.49531 9.9079",
    stroke: "#CBA624"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71051 2.46615C11.0877 3.19658 12.8158 5.40966 12.8158 8.02632C12.8158 8.6848 12.7063 9.31773 12.5047 9.9079",
    stroke: "#CBA624"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11.4474C13.5 11.9063 13.3192 12.3231 13.0251 12.6303C12.7137 12.9554 12.2752 13.1579 11.7895 13.1579C10.8448 13.1579 10.0789 12.3921 10.0789 11.4474C10.0789 10.7597 10.4847 10.1668 11.0699 9.8951C11.2886 9.79353 11.5325 9.73684 11.7895 9.73684C12.7342 9.73684 13.5 10.5027 13.5 11.4474Z",
    stroke: "#CBA624",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92105 11.4474C3.92105 11.9063 3.74028 12.3231 3.44611 12.6303C3.13472 12.9554 2.69628 13.1579 2.21053 13.1579C1.26583 13.1579 0.5 12.3921 0.5 11.4474C0.5 10.7597 0.905785 10.1668 1.49097 9.8951C1.7097 9.79353 1.95349 9.73684 2.21053 9.73684C3.15522 9.73684 3.92105 10.5027 3.92105 11.4474Z",
    stroke: "#CBA624",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71054 2.21053C8.71054 2.66949 8.52977 3.08621 8.2356 3.39342C7.92421 3.71859 7.48577 3.92105 7.00002 3.92105C6.05533 3.92105 5.28949 3.15522 5.28949 2.21053C5.28949 1.52286 5.69526 0.929978 6.28047 0.658258C6.49917 0.556694 6.74299 0.5 7.00002 0.5C7.94471 0.5 8.71054 1.26583 8.71054 2.21053Z",
    stroke: "#CBA624",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/Circle.7269293495d92a2fa777c074b2e79d91.svg";
export { ForwardRef as ReactComponent };